import { symbol } from "../path/shapes";
import markItemPath from "./markItemPath";
export default markItemPath('symbol', symbol);